import React, { useEffect, useState } from 'react'
import { useSnackbar } from '../../../context/SnackBarContext'
import { formatPuchaseOrder } from '../../../utils/utils';
import { PurchaseOrderForm } from '../../../features/Inventory/PuchaseOrderUI/PurchaseOrderForm';
import { useNavigate } from 'react-router-dom';
import TablePurchaseOrder from '../../../features/Inventory/PuchaseOrderUI/TablePurchaseOrder';
import fetcher from '../../../helper/fetcher';
import { useGetPurchaseItems } from '../../../hooks/purchaseOrder';
import { CustomSearch } from "../../../component/CustomSearch"
import { SideDrawer } from "../../../component/SideDrawer/SideDrawer"
import WarningModal from "../../../component/WarningModal"

const PurchaseOrder = () => {
    const navigate = useNavigate()
    const [selectedColorCount, setSelectedColorCount] = useState(0);
    const { showSuccess, showError } = useSnackbar();
    const { product: productsName, params, setParams } = useGetPurchaseItems();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedItm, setSelectedItem] = useState(null)
    const [state, setState] = useState({
        isModalOpen: false,
        selectedContact: null,
        isDrawerOpen: false,
        isContactDrawerOpen: false,
        isProductDrawerOpen: false,
        availableUser: [],
        isLoading: false,
        searchQuery: '',
        memo: '',
        attachment: null,
    })
    const [modalOpen, setModalOpen] = useState(false);
    const [color, setColor] = useState([])
    const [formData, setFormData] = useState({
        supplier: "",
        size: "",
        fabricator: "",
        styleNo: "",
        styleName: "",
        remarks: "",
        orderNo: "",
        dated: "",
        deliveryDate: "",
        deliveryAt: "",
        issueQuantity: '',
        total: "",
    });

    const [tableData, setTableData] = useState({
        productId: "",
        item: [{
            item_name: "",
            avg: 0,
            colQty: 0,
            quantity: 0,
            unit: '',
            rate: 0,
            total: 0,
        }],
        totalColor: 0
    });

    const updateState = (data) => {
        setState((prevState) => {
            const newState = { ...prevState, ...data }
            return newState
        })
    }

    const toggleDrawer = () => setDrawerOpen(!drawerOpen);

    const handleSaveOrder = () => {
        updateState({ isLoading: true })
        const payLoadData = formatPuchaseOrder(formData, tableData, color)
        // console.log("payLoadData ==>>", payLoadData)
        fetcher.post('/inventory/purchase/create_purchase', payLoadData)
            .then((response) => {
                showSuccess(response.data.message)
                setTimeout(() => {
                    navigate("/inventory/manage-purchase-order")
                }, 2000)
            })
            .catch((err) => {
                showError(err.response?.data?.message || "Failed to fetch job data");
            }).finally(() => {
                updateState({ isLoading: false })
            })
    }

    const handleSelectedProduct = (selectedItem) => {
        const newProductId = selectedItem._id || "";
        const newStyleName = selectedItem.styleName;
        const issueQuantity = parseFloat(formData.issueQuantity) || 0;

        const newItems = selectedItem.item.map((itm) => {
            const avg = parseFloat(itm.avg_pics) || 0;
            const rate = parseFloat(itm.rate) || 0;
            const colQty = color.length > 0 ? (issueQuantity / color.length) * avg : 0;
            const quantity = colQty * color.length;
            const total = issueQuantity * avg * rate;

            return {
                item_name: itm.item_name || "",
                avg,
                unit: itm.unit || "",
                rate,
                colQty,
                quantity,
                total
            };
        });

        setTableData({
            productId: newProductId,
            item: newItems,
            totalColor: color.length
        });

        if (!selectedItm) {
            setFormData((prev) => ({ ...prev, styleName: newStyleName }));
        }

        updateState({ isProductDrawerOpen: false });
        setSelectedItem(selectedItem);
    };


    const handleAddProduct = () => {
        updateState({ isProductDrawerOpen: false });
        toggleDrawer();
    };

    useEffect(() => {
        if (selectedItm) {
            handleSelectedProduct(selectedItm);
        }
    }, [formData]);

    console.log("formData ===", formData, "tableData ===>>", tableData, "producttttttttt", color)

    return (
        <div className='bg-white rounded-lg pb-12 min-h-screen'>
            <PurchaseOrderForm
                state={state}
                updateFunc={updateState}
                formData={formData}
                handleSaveOrder={handleSaveOrder}
                setFormData={setFormData}
                setModalOpen={setModalOpen}
                tableData={tableData}
                modalOpen={modalOpen}
                setSelectedColorCount={setSelectedColorCount}
                setColor={setColor}
                color={color}
                setTableData={setTableData}
            />
            <TablePurchaseOrder
                state={state}
                setTableData={setTableData}
                updateFunc={updateState}
                tableData={tableData}
                formData={formData}
            />

            <SideDrawer
                open={state.isProductDrawerOpen}
                onClose={() => updateState({ isProductDrawerOpen: false })}
                title="Add Product"
                headerHidden
            >
                <div className="px-4">
                    <CustomSearch value={params.query} onChange={(e) => setParams((prev) => ({ ...prev, query: e.target.value }))} />
                    <div className="pt-4 max-h-[80vh] overflow-y-auto">
                        {productsName.results?.length > 0 &&
                            productsName.results.map((item, index) => (
                                <p key={index} onClick={() => handleSelectedProduct(item)} className="cursor-pointer hover:text-[#0a3021] p-1">
                                    {item.styleName}
                                </p>
                            ))}
                    </div>
                    <div className="flex justify-between items-center">
                        <button onClick={handleAddProduct} className="bg-[#0a3021] text-white px-4 py-2 rounded">
                            +Add New
                        </button>
                    </div>
                </div>
            </SideDrawer>

            <WarningModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                modalTitle="Are you sure you want to save this Puchase Order?"
                onConfirm={handleSaveOrder}
                onCancel={() => setModalOpen(false)}
                confirmText="Yes, Confirm"
                cancelText="Cancel"
                isLoading={state.isLoading}
                color={false}
            />
        </div>
    )
}

export default PurchaseOrder
